import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import React from 'react';

const UOATableHead = ({ styles, orderBy, order, sortData }) => {
  return (
    <TableHead
      style={{
        backgroundColor: '#000',
      }}
    >
      <TableRow style={{ height: '30px' }}>
        <TableCell width="10px" style={{ padding: '0px' }}></TableCell>
        <TableCell style={styles.headerCellMobile} width="14%" align="center">
          <TableSortLabel
            style={{ color: '#fff' }}
            active={orderBy === 'Symbol'}
            direction={orderBy === 'Symbol' ? order : 'asc'}
            onClick={() => sortData('Symbol')}
          >
            Symbol
          </TableSortLabel>
        </TableCell>
        <TableCell style={styles.headerCellMobile} width="16%" align="center">
          <TableSortLabel
            style={{ color: '#fff' }}
            active={orderBy === 'spot'}
            direction={orderBy === 'spot' ? order : 'asc'}
            onClick={() => sortData('spot')}
          >
            Price
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{ ...styles.headerCellMobile, borderRight: 'none' }}
          width="15%"
          align="center"
        >
          <TableSortLabel
            style={{ color: '#fff' }}
            active={orderBy === 'spotchg'}
            direction={orderBy === 'spotchg' ? order : 'asc'}
            onClick={() => sortData('spotchg')}
          >
            Chg
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.headerCellMobile,
            borderLeft: '1px white solid',
          }}
          width="16%"
          align="center"
        >
          <TableSortLabel
            style={{ color: '#fff' }}
            active={orderBy === 'RV'}
            direction={orderBy === 'RV' ? order : 'asc'}
            onClick={() => sortData('RV')}
          >
            RV
          </TableSortLabel>
        </TableCell>
        <TableCell style={styles.headerCellMobile} width="16%" align="center">
          <TableSortLabel
            style={{ color: '#fff' }}
            active={orderBy === 'volume'}
            direction={orderBy === 'volume' ? order : 'asc'}
            onClick={() => sortData('volume')}
          >
            Vol
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.headerCellMobile,
            borderRight: 'none',
          }}
          width="16%"
          align="center"
        >
          <TableSortLabel
            style={{ color: '#fff' }}
            active={orderBy === 'atmchg'}
            direction={orderBy === 'atmchg' ? order : 'asc'}
            onClick={() => sortData('atmchg')}
          >
            IV%
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
export default UOATableHead;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/UOATableHead.jsx